export const getRowBooleanOperator = (row: string[]) =>
  row[0].trim().toLowerCase();

export const getRowFieldQualifierValue = (row: string[]) => row[1];
